import React, { Component } from 'react';
import {NotificationContainer} from 'react-notifications';
import SigninotpBox from './auth/Signinotp';


class Signin extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div className="ps-account ps-auth-page auth-page-shell">
                <div className="auth-page-shell__ambient auth-page-shell__ambient--one" />
                <div className="auth-page-shell__ambient auth-page-shell__ambient--two" />
                <div className="container auth-page-shell__container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-8 col-xl-6">
                            <div className="auth-card auth-card--centered">
                                <div className="auth-card__header auth-card__header--centered">
                                    <span className="auth-card__eyebrow">Natureway account</span>
                                    <h2>Let's Get You Signed In</h2>
                                </div>
                                <SigninotpBox {...this.props} />
                            </div>
                        </div>
                    </div>
                </div>
                <NotificationContainer />
            </div>
        );
    }
}

export default Signin;
